var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlay = function SvgIconPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.648 2.222a1.75 1.75 0 0 1 1.77.04l13.483 8.244a1.74 1.74 0 0 1 0 2.988L8.42 21.738l-.002.002A1.75 1.75 0 0 1 5.75 20.25V3.749a1.75 1.75 0 0 1 .898-1.527m.72 1.742h.002zm.382.233L20.51 12 7.75 19.803z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPlay;